export enum LinkedRecordListMode {
  Bullets = "Bullets",
  Numbers = "Numbers",
  None = "None",
}
